import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from './store'

interface QuestionState {
	answers: any
}
const initialState: QuestionState = {
	answers: [],
}
export const questionSlicer = createSlice({
	name: 'question',
	initialState,
	reducers: {
		setAnswers: (state, action: PayloadAction<any>) => {
			state.answers = action.payload
		},
	},
})

// Action creators are generated for each case reducer function
export const { setAnswers } = questionSlicer.actions

export const selectSteps = (state: RootState) => state.question.answers

export default questionSlicer.reducer
